// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__CfI3F","logo":"Nav_logo__8jLg9"};